<template>
  <RevButton
    data-qa="go-to-my-order"
    data-test="go-to-my-order"
    full-width="adaptive"
    :to="myOrdersRoute"
    :variant
  >
    {{ i18n(translations.label) }}
  </RevButton>
</template>

<script lang="ts" setup>
import { useRouteLocationWithLocale } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toNuxtLink } from '@backmarket/nuxt-module-navigation/toNuxtLink'
import { RevButton } from '@ds/components/Button'

import { useMyOrdersRouteName } from '@/scopes/customer-care/common/composables/useMyOrdersRouteName'

import translations from './GoToMyOrdersAction.translations'
import type { GoToMyOrdersActionProps } from './GoToMyOrdersAction.types'

const { variant = 'secondary' } = defineProps<GoToMyOrdersActionProps>()

const i18n = useI18n()
const injectLocale = useRouteLocationWithLocale()
const myOrdersRouteName = useMyOrdersRouteName()

const myOrdersRoute = toNuxtLink(
  injectLocale({
    type: 'internal',
    name: myOrdersRouteName.value,
  }),
)
</script>
